import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	strokeWidth: 1.5,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#000000",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6 18.4V5.6C6 5.26863 6.26863 5 6.6 5H9.4C9.73137 5 10 5.26863 10 5.6V18.4C10 18.7314 9.73137 19 9.4 19H6.6C6.26863 19 6 18.7314 6 18.4Z",
		stroke: "#000000",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 18.4V5.6C14 5.26863 14.2686 5 14.6 5H17.4C17.7314 5 18 5.26863 18 5.6V18.4C18 18.7314 17.7314 19 17.4 19H14.6C14.2686 19 14 18.7314 14 18.4Z",
		stroke: "#000000",
		strokeWidth: 1.5
	})]
});
export default SvgPause;
